import React from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
} from "@mui/material";

import { ModalTransition } from "../../components/shared/Dialog/Config";

/** Standard create/edit dialog of the distribution portal; children are Grid items. */
const EDCFormDialog = ({ open, title, saving = false, onClose, onSave, maxWidth = "md", children }) => (
  <Dialog
    open={open}
    onClose={() => !saving && onClose()}
    TransitionComponent={ModalTransition}
    fullWidth
    maxWidth={maxWidth}
  >
    <DialogTitle>{title}</DialogTitle>
    <Divider />
    <DialogContent>
      <Grid container spacing={2} sx={{ mt: 0 }}>
        {children}
      </Grid>
    </DialogContent>
    <Divider />
    <DialogActions sx={{ px: 3, py: 1.5 }}>
      <Button onClick={onClose} disabled={saving}>
        انصراف
      </Button>
      <Button
        variant="contained"
        disabled={saving}
        onClick={onSave}
        startIcon={saving ? <CircularProgress size={16} color="inherit" /> : null}
      >
        ذخیره
      </Button>
    </DialogActions>
  </Dialog>
);

export default EDCFormDialog;
